import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BsDropdownConfig, BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { ApplicationLauncherComponent } from './application-launcher.component';

/**
 * A module containing objects associated with the application laucnher components
 */

export class ApplicationLauncherModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    BsDropdownModule.forRoot(),
    CommonModule
  ],
  declarations: [ApplicationLauncherComponent],
  exports: [ApplicationLauncherComponent],
  providers: [BsDropdownConfig]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
